import { ItemsListContainerBase } from '../../../components/items-list-container-base';
import { Component, OnInit, Input, Injector, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { FormReportActiveColleaguesListData } from './fi-form-report-active-colleagues-list-data';
import { FiStateNames } from '../../../shared/fi-state-proxy/fi-state-names';
import { IFormReportActiveColleague } from '@fi-app/fi-form/fi-form-report/fi-form-report';
import { UserService } from '@fi-app/user/user.service';

@Component({
    selector: 'fi-form-report-active-colleagues-list',
    template: `
        <mat-card class="fi-form-report-card">
            <mat-card-title class="BrandedBackgroundColor mat-card-title-text-center-container">
                <!--<div class="fi-form-report-back-button-wrapper">
                        <mat-icon (click)="goBack()" class="fi-form-report-back-icon cursor-pointer">
                            <span class="fa fa-chevron-left"></span>
                        </mat-icon>
                        <span (click)="goBack()" class="cursor-pointer">{{"back" | fiAppText}}</span>
                    </div>-->
                <span class="fi-form-report-title-text">{{ 'form.active_colleagues_header' | fiAppText }}</span>
                <div class="fi-form-report-additional-item"></div>
            </mat-card-title>
            <mat-card-content>
                <p class="fi-form-report-description-paragraph">
                    {{ 'form.active_colleagues_description' | fiAppText }}
                </p>
                <div class="fi-form-report-item-list-wrapper">
                    <fi-items-list [settings]="ListData" [module]="[FiStateNames.Form._name]"></fi-items-list>
                </div>
            </mat-card-content>
        </mat-card>
    `,
    styleUrls: ['../fi-form-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiFormReportActiveColleaguesListComponent
    extends ItemsListContainerBase<FormReportActiveColleaguesListData>
    implements OnInit
{
    @Input() activeColleagues: IFormReportActiveColleague[];
    @Output() back = new EventEmitter();
    FiStateNames = FiStateNames;

    constructor(
        private injector: Injector,
        private userService: UserService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () =>
                new FormReportActiveColleaguesListData(this.injector, (data) =>
                    setTimeout(() => {
                        this.userService.openUserViewDialog(data.Id);
                    }),
                ),
            {
                noLocalSearch: true,
                showDelete: false,
            },
        );
    }

    goBack() {
        this.back.emit();
    }

    protected LoadItems() {
        this.ListData.Data = this.activeColleagues;
        return Promise.resolve();
    }

    protected SetItemsCount() {
        return Promise.resolve(this.activeColleagues.length);
    }
}
